import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Input, Label, TabContent, TabPane } from "reactstrap";
import {
  getMemberBenefits,
  updateIndividualMemberBenefits,
  updateParentMemberBenefits,
} from "../../../store/slices/memberBenefitsSlice";
import { H5 } from "../../../AbstractElements";
import CreatetableSelect from "react-select/creatable";

const MemberBenefits = ({ program }) => {
  const dispatch = useDispatch();
  const [mbCards, setMbCards] = useState([]);
  const [render, setRender] = useState(false);
  const [benefitMode, setBenefitMode] = useState([
    { value: "complementary", label: "Complementary" },
    { value: "value", label: "Value" },
  ]);
  const [typeOfBenefit, setTypeOfBendit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);
  const [valueBenefitType, setValueBenefitType] = useState([
    { value: "percentage", label: "Percentage" },
    { value: "flat", label: "Flat" },
  ]);
  useEffect(() => {
    getMBofProgram();
  }, [program]);

  const getMBofProgram = async () => {
    let MBDATA = await dispatch(getMemberBenefits(program.ID));
    if (MBDATA?.payload) {
      setMbCards(MBDATA?.payload);
    }
  };

  const handleInputParent = (event, index, field) => {
    let cards = mbCards;
    if (field === "total_quantity" || field === "total_percentage") {
      cards[index] = {
        ...cards[index],
        [field]: parseInt(event.target.value),
        isEdit: true,
      };
    } else if (field === "max_amount") {
      cards[index] = {
        ...cards[index],
        [field]: event.target.value,
        isEdit: true,
      };
    } else {
      cards[index] = { ...cards[index], [field]: event.value, isEdit: true };
    }
    setMbCards(cards);
    setRender(!render);
  };

  const handleInputIndividual = (event, index, imbIndex, field) => {
    let cards = mbCards;
    console.log(cards[index][imbIndex], index, imbIndex, "MB");
    if (field === "total_quantity" || field === "total_percentage") {
      cards[index].IndividalMemberBenefits[imbIndex] = {
        ...cards[index].IndividalMemberBenefits[imbIndex],
        [field]: parseInt(event.target.value),
        isEdit: true,
      };
    } else if (field === "max_amount") {
      cards[index].IndividalMemberBenefits[imbIndex] = {
        ...cards[index].IndividalMemberBenefits[imbIndex],
        [field]: event.target.value,
        isEdit: true,
      };
    } else {
      cards[index].IndividalMemberBenefits[imbIndex] = {
        ...cards[index].IndividalMemberBenefits[imbIndex],
        [field]: event.value,
        isEdit: true,
      };
    }
    setMbCards(cards);
    setRender(!render);
  };

  const updateParentMB = async (MB, index) => {
    const { isEdit, IndividalMemberBenefits, created_at, last_updated, program_id, service_id, ...payload } = MB;
    let result = await dispatch(updateParentMemberBenefits(payload));
    if (result?.payload) {
      let cards = mbCards;
      delete cards[index].isEdit;
      setMbCards(cards);
      setRender(!render);
    }
  };

  const updateIndividualMB = async (MB, index, imbIndex) => {
    const { isEdit, IndividalMemberBenefits, created_at, last_updated, program_id, service_id, ...payload } = MB;
    let result = await dispatch(updateIndividualMemberBenefits(payload));
    if (result?.payload) {
      let cards = mbCards;
      delete cards[index].IndividalMemberBenefits[imbIndex].isEdit;
      setMbCards(cards);
      setRender(!render);
    }
  };

  useEffect(() => {
    console.log(mbCards, "cards 1");
  }, [render]);

  return (
    <div>
      {mbCards?.map((card, index) => {
        return (
          <Card className="p-4" key={`mbCard-${index}`}>
            <H5>{card?.benefit_name}</H5>
            <div className="d-flex ">
              <div className="mt-2 w-50">
                <Label>Type of Benefit</Label>
                <CreatetableSelect
                  options={typeOfBenefit}
                  onChange={(event) => handleInputParent(event, index, "type")}
                  value={typeOfBenefit.filter((x) => x.value === card.type)}
                />
              </div>
              {card.type === "grouped" ? (
                <div className="mt-2 w-50">
                  <Label>Select mode</Label>
                  <CreatetableSelect
                    options={benefitMode}
                    onChange={(event) =>
                      handleInputParent(event, index, "benefitMode")
                    }
                    value={benefitMode.filter(
                      (x) => x.value === card.benefitMode
                    )}
                    isClearable
                  />
                </div>
              ) : null}
            </div>

            {card.benefitMode === "value" && card.type === "grouped" ? (
              <div className="d-flex">
                <div className="mt-2 w-50">
                  <Label>Select mode</Label>
                  <CreatetableSelect
                    options={valueBenefitType}
                    onChange={(event) =>
                      handleInputParent(event, index, "valueBenefitType")
                    }
                    value={valueBenefitType.filter(
                      (x) => x.value === card.valueBenefitType
                    )}
                    isClearable
                  />
                </div>

                <div className="mt-2 w-50">
                  <Label>Amount/Percentage</Label>
                  <Input
                    type="number"
                    placeholder="Enter amount/percentage"
                    value={card.total_percentage}
                    max={card.valueBenefitType === "percentage" ? 100 : null}
                    onChange={(event) =>
                      handleInputParent(event, index, "total_percentage")
                    }
                  ></Input>
                </div>
              </div>
            ) : null}
            {card?.type === "grouped" ? (
              <div className="d-flex">
                <div className="mt-2 w-50">
                  <Label>MB count</Label>
                  <Input
                    type="number"
                    placeholder="Enter count"
                    value={card.total_quantity}
                    onChange={(event) =>
                      handleInputParent(event, index, "total_quantity")
                    }
                  ></Input>
                </div>
                <div className="mt-2 w-50">
                  <Label>Max amount</Label>
                  <Input
                    type="text"
                    placeholder="Enter max amount"
                    value={card.max_amount}
                    onChange={(event) =>
                      handleInputParent(event, index, "max_amount")
                    }
                  ></Input>
                </div>
              </div>
            ) : null}
            {card?.isEdit ? (
              <div className="mt-2 d-flex justify-content-end">
                <Button onClick={() => updateParentMB(card, index)}>
                  Save
                </Button>
              </div>
            ) : null}
            {card.type === "individual"
              ? card?.IndividalMemberBenefits?.map((imb, imbIndex) => {
                  return (
                    <div
                      className="mt-4"
                      key={`IndividalMemberBenefits-${imbIndex}`}
                    >
                      <hr></hr>
                      <H5>{imb.benefit_name}</H5>
                      <div className="mt-2 w-full">
                        <Label>Select mode</Label>
                        <CreatetableSelect
                          options={benefitMode}
                          onChange={(event) =>
                            handleInputIndividual(
                              event,
                              index,
                              imbIndex,
                              "benefitMode"
                            )
                          }
                          value={benefitMode.filter(
                            (x) => x.value === imb.benefitMode
                          )}
                          isClearable
                        />
                      </div>
                      {imb.benefitMode === "value" ? (
                        <div className="d-flex">
                          <div className="mt-2 w-50">
                            <Label>Select mode</Label>
                            <CreatetableSelect
                              options={valueBenefitType}
                              onChange={(event) =>
                                handleInputIndividual(
                                  event,
                                  index,
                                  imbIndex,
                                  "valueBenefitType"
                                )
                              }
                              value={valueBenefitType.filter(
                                (x) => x.value === imb.valueBenefitType
                              )}
                              isClearable
                            />
                          </div>
                          <div className="mt-2 w-50">
                            <Label>Amount/Percentage</Label>
                            <Input
                              type="number"
                              placeholder="Enter amount/percentage"
                              value={imb.total_percentage}
                              onChange={(event) =>
                                handleInputIndividual(
                                  event,
                                  index,
                                  imbIndex,
                                  "total_percentage"
                                )
                              }
                            ></Input>
                          </div>
                        </div>
                      ) : null}
                      <div className="d-flex">
                        <div className="mt-2 w-50">
                          <Label>MB count</Label>
                          <Input
                            type="number"
                            placeholder="Enter count"
                            value={imb.total_quantity}
                            onChange={(event) =>
                              handleInputIndividual(
                                event,
                                index,
                                imbIndex,
                                "total_quantity"
                              )
                            }
                          ></Input>
                        </div>
                        <div className="mt-2 w-50">
                          <Label>Max amount</Label>
                          <Input
                            type="text"
                            placeholder="Enter max amount"
                            value={imb.max_amount}
                            onChange={(event) =>
                              handleInputIndividual(
                                event,
                                index,
                                imbIndex,
                                "max_amount"
                              )
                            }
                          ></Input>
                        </div>
                      </div>
                      {imb?.isEdit ? (
                        <div className="mt-2 d-flex justify-content-end">
                          <Button
                            onClick={() =>
                              updateIndividualMB(imb, index, imbIndex)
                            }
                          >
                            Save
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  );
                })
              : null}
          </Card>
        );
      })}
    </div>
  );
};

export default MemberBenefits;
